// extracted by mini-css-extract-plugin
export default {"peopleCount":"styles_peopleCount__mSV+R","title":"styles_title__9XIsQ","box":"styles_box__kiEGg","boxImage":"styles_boxImage__2npCG","boxText":"styles_boxText__baiXA"};